import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams } from "../apiService/timespam";
import "./Theme.css";
import "./TermsOfServices.css";

const TermsOfServices = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  return (
    <section className="tos-page">
      <div className="tos-container">
        <h1 className="tos-heading">{t("termsOfService.title")}</h1>
        <p className="tos-text">{t("termsOfService.intro")}</p>
        <h2 className="tos-subheading">{t("termsOfService.useTitle")}</h2>
        <p className="tos-text">{t("termsOfService.useBody")}</p>
        <h2 className="tos-subheading">{t("termsOfService.limitTitle")}</h2>
        <p className="tos-text">{t("termsOfService.limitBody")}</p>
        <h2 className="tos-subheading">{t("termsOfService.contactTitle")}</h2>
        <p className="tos-text">{t("termsOfService.contactBody")}</p>
      </div>
    </section>
  );
};

export default TermsOfServices;
